import { create } from 'zustand';
import { ApiUtils, Product, ProductApi, RequestStrategyEnum } from '@shared/api';

interface IProductsStore {
  loading: boolean;
  error: string | null;
  products: Product[];
  getProducts: (signal?: AbortSignal) => Promise<void>;
  clear: () => void;
}

export const useProductsStore = create<IProductsStore>((set) => ({
  loading: false,
  error: null,
  products: [],

  getProducts: ApiUtils.wrapperApi(async (signal?: AbortSignal) => {
    try {
      set({ loading: true, error: null });
      const result = await ProductApi.getProducts(signal);
      set({ products: result ?? [], loading: false });
    } catch (error) {
      set({ error: (error as Error).message, loading: false });
    }
  }, RequestStrategyEnum.Debounce),

  clear: () => set({ products: [], loading: false, error: null }),
}));
